import React from "react";
import { useTranslation } from "react-i18next";
import "./TimelineSelector.css";

export const TimelineSelector = ({ timeArray, actions }) => {
  const { t } = useTranslation();
  if (!timeArray || timeArray.length === 0) {
    return <div>{t("timepoints.noTimepointsAvailable")}</div>;
  }

  const times = timeArray.map((t) => new Date(t.time).getTime());
  const minTime = Math.min(...times);
  const maxTime = Math.max(...times);

  const getPosition = (time) => {
    const currentTime = new Date(time).getTime();
    return ((currentTime - minTime) / (maxTime - minTime)) * 100;
  };


  return (
    <div className="timeline-selector">
      <div className="timeline-line">
        {timeArray.map(({ time, actionId }, index) => {
          const action = actions.find((action) => action.id === actionId);
          return (
            <div
              key={'timeline-dot-' + index}
              className="timeline-dot"
              style={{ left: `${getPosition(time)}%`, backgroundColor: action?.color }}
            >
              <div className="timeline-popup popover">
                <p className="timeline-time">
                  {new Date(time).toLocaleString()}
                </p>
                <p className="timeline-type">
                  {action?.name || t("common.unknown")}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
